
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","opacity":".5","d":"M4.109 10.396a1.135 1.135 0 000 1.605l2.981 2.982a1.135 1.135 0 001.605 0L11.677 12a1.135 1.135 0 10-1.606-1.605l-1.043 1.043V1.605a1.135 1.135 0 00-2.27 0v9.834l-1.044-1.043a1.135 1.135 0 00-1.605 0z","fill":"currentColor"}})])
          )
        }
      }
    